import { fetchHoldings, fetchPositions } from "../services/kiteService";

export const usePortfolio = () => {
  const fetchLatestHoldings = async () => {
    try {
      const response = await fetchHoldings();
      return response;
    } catch (error) {
      console.error("Error fetching holdings:", error);
    }
  };
  const fetchLatestPositions = async () => {
    try {
      const response = await fetchPositions();
      return response;
    } catch (error) {
      console.error("Error fetching positions:", error);
    }
  };

  // Fetch best stocks based on criteria
  const fetchBestStocks = async (): Promise<any> => {
    try {
      // Simulate API call or use mock data (replace with actual fetch)
      // const response = await fetch('/api/scanner-data'); // Example API call
      // const data = await response.json();
      let data;
      await fetchLatestHoldings().then((res) => {
        data = res;
      }); // Use mock data for now

      // Filter best stocks
      const bestStocks = data.filter((stock) => {
        const isTechnicalGood = stock.technicalScore >= 60;
        const isFundamentalGood = stock.fundamentalScore >= 50;
        const isVolumeGood = stock.volume > 50;
        const isATRGood = stock.atr >= 2 && stock.atr <= 6;
        return (
          isTechnicalGood && isFundamentalGood && isVolumeGood && isATRGood
        );
      });

      // Limit to 2 stocks per sector
      const sectorCount: Record<string, number> = {};
      const filteredStocks = bestStocks.filter((stock) => {
        sectorCount[stock.sector] = (sectorCount[stock.sector] || 0) + 1;
        return sectorCount[stock.sector] <= 2;
      });

      // Sort by combined score
      filteredStocks.sort(
        (a, b) =>
          b.technicalScore +
          b.fundamentalScore -
          (a.technicalScore + a.fundamentalScore)
      );

      return filteredStocks.map((stock) => ({
        ...stock,
        symbol: stock.tradingsymbol, // For DataGrid compatibility
        score: stock.technicalScore + stock.fundamentalScore, // Combined score for display
      }));
    } catch (error) {
      console.error("Error fetching best stocks:", error);
      return [];
    }
  };

  return {
    fetchLatestHoldings,
    fetchLatestPositions,
    fetchBestStocks,
  };
};
